import { render, staticRenderFns } from "./VideoSpecimenListv2.vue?vue&type=template&id=4b62c8f5&scoped=true"
import script from "./VideoSpecimenListv2.vue?vue&type=script&lang=js"
export * from "./VideoSpecimenListv2.vue?vue&type=script&lang=js"
import style0 from "./VideoSpecimenListv2.vue?vue&type=style&index=0&id=4b62c8f5&prod&lang=css"
import style1 from "./VideoSpecimenListv2.vue?vue&type=style&index=1&id=4b62c8f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b62c8f5",
  null
  
)

export default component.exports